import React, { useEffect } from 'react';
import CommonHeader from '@/components/CommonHeader';
import Active from './component/active';

import './index.less';
import $i18n from '../../i18n';

const breadcrumbConfig = [
  {
    key: 'miniapp',
    breadcrumbName: $i18n.get({ id: 'aopf.pages.miniapp.ApplicationList', dm: '应用列表' }),
    path: '/miniapp',
  },
];

const MiniappList: React.FC = () => {
  return (
    <div className="global-filter-list">
      <CommonHeader
        title={$i18n.get({ id: 'aopf.pages.miniapp.Miniapp.List', dm: '应用列表' })}
        breadcrumbs={breadcrumbConfig}
      />
      <Active />
    </div>
  );
};

export default MiniappList;
